import { DataBean } from "../DataBean";

export class Countries extends DataBean {



    public async deleteCountries(idCountries: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteCountries_Number", [idCountries]);
    }
    public async getDefaultCountry(): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.site.Countries_getDefaultCountry_Number", [null]);
    }

    public async getCountriesCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getCountriesCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }
    public async getTreeForSiteID(idCountries: number): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Tree_getTreeForSiteID_Number", [idCountries]);
    }



}